{
  "fr": {
    "aiDocumentQa": {
      "buttons": {
        "chooseFile": "Sélectionner un fichier",
        "loadMore": "Charger plus"
      },
      "confirm": {
        "deleteDocumentChat": {
          "text": "Cette action est irréversible. Le document sera définitivement supprimé avec tout l'historique de la discussion.",
          "title": "Supprimer le chat du document ?"
        }
      },
      "hints": {
        "documentIsBeingProcessed": "Document en cours d'analyse...",
        "dropFile": "Glisser le PDF ici ou",
        "fileLimit": "(maximum 10 Mo)"
      },
      "labels": {
        "words": "{count} mots"
      },
      "paragraphs": {
        "intro": "Téléchargez un document et laissez l'IA résumer le contenu, créer des paires de questions-réponses pour des cartes d'apprentissage ou répondre à des questions sur le contenu. Notez que les images et tableaux dans les documents ne sont pas lisibles par l'IA."
      },
      "statusMessages": {
        "indexing": "Les connaissances de fond sont indexées",
        "indexingStatus": "Indexation"
      }
    }
  }
}
